var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 7,
    viewBox: "0 0 9 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0002 0.499924C7.60967 0.1094 6.97651 0.1094 6.58598 0.499924L3.25004 3.83587L2.00008 2.58591C1.60955 2.19539 0.976386 2.19539 0.585862 2.58591C0.195338 2.97643 0.195337 3.6096 0.585862 4.00012L2.53896 5.95322C2.66334 6.0776 2.81234 6.16237 2.97027 6.20752C3.30974 6.30694 3.69157 6.22276 3.95933 5.955L8.0002 1.91414C8.39072 1.52361 8.39072 0.890449 8.0002 0.499924Z",
    fill: "#32C1E9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckNew);
export default __webpack_public_path__ + "static/media/check-new.edaf35bd3b6c1bff5d53fb6e9f5cda4e.svg";
export { ForwardRef as ReactComponent };